export const detectPlatform = () => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const mobileRegex = /Android|iPhone|iPad|iPod|BlackBerry|Mobile/i;

    const isMobileDevice = mobileRegex.test(userAgent);
    if (isMobileDevice) {
        return 'phone'
    }

    // 检测 Windows
    if (userAgent.includes('Win')) {
        return 'win';
    }

    // 检测 macOS
    if (userAgent.includes('Mac')) {
        // 检测 Apple Silicon (M芯片)
        if (navigator.userAgent.includes('Apple') &&
            !navigator.userAgent.includes('Intel') &&
            !navigator.userAgent.includes('x86')) {
            return 'mac_m';
        }

        // 检测 Intel Mac
        if (userAgent.includes('Intel') ||
            userAgent.includes('x86') ||
            platform === 'MacIntel') {
            return 'mac_intel';
        }

        // 其他情况默认为 Apple Silicon (较新的 Mac 通常为 M芯片)
        return 'mac_m';
    }

    return 'other';
}

export const timeFormat = (time, format) => {
    var o = {
        "M+": time.getMonth() + 1,                      //month
        "d+": time.getDate(),                           //day
        "h+": time.getHours(),                          //hour
        "m+": time.getMinutes(),                        //minute
        "s+": time.getSeconds(),                        //second
        "q+": Math.floor((time.getMonth() + 3) / 3),    //quarter
        "S": time.getMilliseconds()                     //millisecond
    }

    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

export const getUrlParams = (params) => {
    const urlObj = new URL(window.location.href)
    const query = urlObj.searchParams.get(params)
    if (query) {
        return query
    }
    return ''
}

export const hideUrlParam = (str) => {
    // 获取当前页面的URL
    const url = window.location.href;
    const newUrlObj = new URL(url);
    newUrlObj.searchParams.delete(str);
    // 更新URL对象后重新生成完整的URL字符串
    const hiddenLink = newUrlObj.toString();
    if (history.replaceState) history.replaceState({}, "", hiddenLink);
}

export const validateEmail = (email) => {
    // 常用邮箱正则表达式
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(email);
}

export const validatePassword = (password) => {
    //检测密码只有数字、字母和符号，不包含空格
    // 正则表达式：匹配一个或多个数字、字母或常见符号
    // ^ 表示开始，$ 表示结束，[] 内是允许的字符
    // 0-9a-zA-Z 表示数字和字母
    // 添加常见符号（可以根据需要调整）
    // 这里添加了常见符号：!@#$%^&*()_+-=[]{}|;:',.<>/?`~
    return /^[0-9a-zA-Z!@#$%^&*()_+\-=\[\]{}|;:',.<>/?`~]+$/.test(password);
}
